import { Box, Chip, Typography } from '@mui/material';
import { versionStatus, windowText } from './effectiveWindow';
import SetBy from './SetBy';

// "When does this threshold apply" under the headline of a single-value threshold screen (SFR, Fee Collection, ...). With
// one version the screen used to show only "Warning when SFR is below 30%" and Active - no time frame at all, so there was
// no way to see that it starts in October and does nothing for earlier months. Always shown, for the version on screen:
//   Applies from Oct 2026 onward   [Scheduled]
//   Not in force in April 2026 (the working month) - it starts October 2026.
const STATUS_COLOR = { Current: 'success', Scheduled: 'info', Ended: 'default' };

const AppliesLine = ({ row, month }) => {
  if (!row) return null;
  const status = versionStatus(row, month);
  const start = new Date(String(row.effective_from).slice(0, 10) + 'T00:00:00').toLocaleString('en-GB', { month: 'long', year: 'numeric' });
  const text = row.effective_to ? `Applies ${windowText(row).replace(' only', ' only')}` : `Applies from ${windowText(row).replace(/^From /, '')} onward`;
  const working = month.format('MMMM YYYY');

  return (
    <Box sx={{ mt: 1.5 }}>
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <Typography variant="body2">{text}</Typography>
        <Chip size="small" variant="outlined" color={STATUS_COLOR[status]} label={status === 'Current' ? `In force in ${working}` : status} />
      </Box>
      <SetBy name={row.created_by_name} at={row.created_at} />
      {status === 'Scheduled' && (
        <Typography variant="body2" color="text.secondary">
          Not in force in {working} (the working month) - it starts {start}. To cover {working}, edit it and set Applies from to {working} or earlier.
        </Typography>
      )}
      {status === 'Ended' && (
        <Typography variant="body2" color="text.secondary">Ended before {working} (the working month).</Typography>
      )}
    </Box>
  );
};

export default AppliesLine;
